<main #contentLoaded id="main" class="list-height article-main">
    <button tabindex="0" role="button" class="buttons-toolbar display {{tooltipStatus}}" (click)="scrollToTopfn()"
        [ngStyle]="{'left.px': aricleContentAreaWidth}" aria-label="Press enter to back to top"
        (keyup.enter)="scrollToTopfn()" (keyup.space)="scrollToTopfn()" #scrollToTop
        [ngbTooltip]="'article_view.arrow_up'|translate" [placement]="'top'">
        <fa-icon aria-hidden="true" class="showAbove" [icon]="['fas', 'arrow-up']">
        </fa-icon>
    </button>

    <section #articleView id="" class="pt-0" aria-label="article view page">
        <div class="container-fluid">
            <div class="row w-100 article-view-page-content" style="width: 105% !important;">
                <div
                    [ngClass]="expanded?'col-md-12 view-content slide-in full-content':'col-sm-12  col-md-12 col-lg-9 col-xl-9 col-xxl-9 article-section'">
                    <div #aricleContentArea class="article-view-box article-view-content-div">

                        <div class="article-title-content-wrapper row">
                            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-7">
                                <nav aria-label="Breadcrumb">
                                    <ol class="article-breadcrumb-sec" *ngIf="articlelist && !loading">

                                        <li>
                                            <button (click)="goToPage('')" class="breadcrumb-nav"
                                                title="{{ articlelist.journal_title }}">
                                                <span class="nav-string nav-string-home">
                                                    {{ articlelist.journal_title | truncate:15 }}
                                                </span>
                                                <fa-icon aria-hidden="true" class="angle-icon"
                                                    [icon]="['fas', 'angle-right']"></fa-icon>
                                            </button>
                                        </li>

                                        <li>
                                            <button (click)="goToPage('volumes')" class="breadcrumb-nav"
                                                title="Volume {{ articlelist.volume_id }}">
                                                <span class="nav-string">
                                                    Volume {{ articlelist.volume_id | truncate:15 }}
                                                </span>
                                                <fa-icon aria-hidden="true" class="angle-icon"
                                                    [icon]="['fas', 'angle-right']"></fa-icon>
                                            </button>
                                        </li>

                                        <li>
                                            <button
                                                (click)="goToPage('articles/' + articlelist.volume_id + '/' + articlelist.issue_id)"
                                                class="breadcrumb-nav"
                                                title="Issue {{ changeIssue(articlelist.issue_id) }}">
                                                <span class="nav-string">
                                                    {{ changeIssue(articlelist.issue_id) | truncate:15 }}
                                                </span>
                                                <fa-icon aria-hidden="true" class="angle-icon"
                                                    [icon]="['fas', 'angle-right']"></fa-icon>
                                            </button>
                                        </li>

                                        <li>
                                            <span title="{{ getCleanTitle(articlelist.article_title) }}">
                                                {{ setTitle(getCleanTitle(articlelist.article_title)) | truncate:15 }}
                                            </span>
                                        </li>
                                    </ol>
                                </nav>
                            </div>

                            <div
                                class="article-button-content col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-5 d-flex justify-content-end">
                                <span class="mr-2" *ngIf="!hideExpanIcon">
                                    <div #expantooltip [ngClass]="expanded ? 'active-icon' : 'inactive-icon'"
                                        tabindex="0" aria-label="Press enter to change layout of the article"
                                        role="button" (click)="toggleExpand()" (keyup.enter)="toggleExpand()"
                                        (keyup.space)="toggleExpand()" (mouseenter)="setTooltipMsg()" placement="bottom"
                                        [title]="titleMsg && !expanded?'Change the article layout to full width ':'Exit fullwidth layout'"
                                        triggers="click" [openDelay]="1000" [closeDelay]="200"
                                        tooltipClass="color-change-tootltip"
                                        [ngbTooltip]="expanded?'You have switched your layout to full width. To go back to fixed width, press this button.':''">
                                        <fa-icon aria-hidden="true"
                                            [icon]="expanded?['fas', 'compress']:['fas', 'expand']"></fa-icon>
                                    </div>
                                </span>
                                <div class="article-view-wrapper me-3" *ngIf='loading'>
                                    &nbsp;&nbsp;&nbsp;
                                    <span *ngIf="loading" class="me-2 article-view-normal content-loader">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                    <span *ngIf="loading" class="article-view-dyslexic content-loader">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </div>
                                <div class="article-view-wrapper me-3" *ngIf='!loading &&  viewActiveIcon==="normal"'>
                                    <fa-icon aria-hidden="true" class="me-3 icon-font" [icon]="['fas', 'eye']">
                                    </fa-icon>
                                    <span class="me-2 article-view-normal" (click)="openDyslexic('normal')" tabindex="0"
                                        role="button" (keyup.enter)="openDyslexic('normal')"
                                        (keyup.space)="openDyslexic('normal')" #scrollToTop
                                        [ngbTooltip]="'article_view.Normal_view'|translate" [placement]="'bottom'">
                                        Normal View </span>

                                    <span class="article-view-dyslexic" (click)="openDyslexic('Dyslexic')" tabindex="0"
                                        role="button" (keyup.enter)="openDyslexic('Dyslexic')"
                                        (keyup.space)="openDyslexic('Dyslexic')" #scrollToTop
                                        [ngbTooltip]="'article_view.Dyslexic_view'|translate" [placement]="'bottom'">
                                        Dyslexic View
                                    </span>
                                </div>
                                <div class="article-view-wrapper me-3" *ngIf=' !loading && viewActiveIcon==="Dyslexic"'>
                                    <fa-icon aria-hidden="true" class="me-3" [icon]="['fas', 'eye']">
                                    </fa-icon>
                                    <span class="me-2 article-view-dyslexic" (click)="openDyslexic('normal')"
                                        role="button" tabindex="0" (keyup.enter)="openDyslexic('normal')"
                                        (keyup.space)="openDyslexic('normal')" #scrollToTop
                                        [ngbTooltip]="'article_view.Normal_view'|translate" [placement]="'bottom'">
                                        Normal View </span>
                                    <span class="article-view-normal" (click)="openDyslexic('Dyslexic')" tabindex="0"
                                        (keyup.enter)="openDyslexic('Dyslexic')"
                                        (keyup.space)="openDyslexic('Dyslexic')" #scrollToTop>
                                        Dyslexic View
                                    </span>
                                </div>
                                <span class="image-iconspan ml-3">
                                    <img *ngIf="loading" class="open-access-logo content-loader">
                                    <img *ngIf="!loading" src='assets/logos/open_access_logo.webp' width="20"
                                        height="20" class="open-access-logo"
                                        [ngbTooltip]="'article_listing.open_access'|translate" [placement]="'bottom'"
                                        alt="Open access article">
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="article-title-content col-12">
                                <h1 *ngIf="loading" class="content-loader">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </h1>
                                <!-- <h1 *ngIf="!loading">{{setArticleType(articlelist.subject_heading)}} </h1> -->
                                <h1 *ngIf="!loading">{{articlelist.subject_heading}} </h1>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12  col-xl-12 col-xxl-12rvh-artic-basic-info"
                                #basicInfo>
                                <span class="d-flex justify-content ">
                                    <h2 *ngIf="loading" class="rvh-article-title-name content-loader">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </h2>
                                    <h2 *ngIf="!loading" class="rvh-article-title-name" tabindex="0"
                                        [innerHTML]="structuringData(articlelist.article_title) | highlightSearch:''"
                                        (mouseover)="showTooltip($event)" (mousemove)="leaveTooltip($event,'content')"
                                        (mouseleave)="leaveTooltip($event,'content')">
                                    </h2>
                                </span>
                                <p *ngIf="loading" class=" pt-0 pb-2 author content-loader">
                                </p>
                                <p *ngIf="!loading" class=" pt-0 pb-2 author" tabindex="0"
                                    [innerHTML]="structuringData(getAuthorlist(articlelist.authors))| highlightSearch:''"
                                    (mousemove)="leaveTooltip($event,'author')"
                                    (mouseleave)="leaveTooltip($event,'author')">
                                </p>
                                <!-- <p class="pt-0" tabindex="0">
                                        <span class="pr-4 rvh-article-analytics-sec">
                                            <fa-icon class="iconcls pr-2" aria-hidden="true" [icon]="['fas', 'download']">
                                            </fa-icon>
                                            <span tabindex="0" class="second-title" *ngIf="articlelist.download_count!==null">
                                                {{articlelist.download_count}} </span>
                                            <span tabindex="0" class="second-title" *ngIf="articlelist.download_count===null"> 0 </span>
                                        </span>
                                        <span class="pr-4 rvh-article-analytics-sec">
                                            <fa-icon class="iconcls pr-2" aria-hidden="true" [icon]="['fas', 'eye']">
                                            </fa-icon>
                                            <span tabindex="0" class="second-title" *ngIf="articlelist.view_count!==null">
                                                {{articlelist.view_count}} </span>
                                            <span tabindex="0" class="second-title" *ngIf="articlelist.view_count===null"> 0 </span>
                                        </span>
                                    </p> -->

                                <!-- <span class="doi"> <span tabindex="0">{{'article_listing.doi' | translate}}:</span>
                                        <fa-icon class="iconcls" aria-hidden="true"
                                            [icon]="['fas', 'earth-americas']"></fa-icon>
                                        <a class="link" target="_blank" href="https://doi.org/{{articlelist.doi}}">
                                            {{articlelist.doi}}</a></span> -->

                                <!-- <div class="row">
                                        <div class="col d-flex" *ngIf="articlelist.keywords && articlelist.keywords.length!==0">
                                            <div class="theme-blue colum-width" *ngFor="let keyword of articlelist.keywords">
                                                <span class="badge badge-primary badge-right p-1 button-primary" tabindex="0"
                                                    tabindex="0"> &#x2022;
                                                    {{keyword}}
                                                </span>
                                            </div>
                                        </div>
                                    </div> -->
                                <!-- <div class="row pt-4 zindex" data-aos="fade-up" #articleAbstract> -->
                                <div class="col-sm-12 col-md-12 mt-2">
                                    <h3 *ngIf="loading" class=" content-loader" style="width: 13% ">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                    </h3>
                                    <h3 *ngIf="!loading" class="article-detail" tabindex="0">
                                        {{'article_listing.abstract' |
                                        translate}}
                                    </h3>
                                    <div *ngIf="loading">
                                        <p *ngFor="let item of abstractcontentloader; let i = index">
                                            <span class="content-loader about-content"></span>
                                        </p>
                                    </div>
                                    <p *ngIf="!loading" class="abstract-content justify-content text-color" tabindex="0"
                                        [innerHTML]="structuringData(articlelist.abstract)">
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-2 " data-aos="fade-up" *ngIf="loading">
                            <div class="col-sm-12 col-md-12" data-aos="fade-up">
                                <h4 class="article-detail content-loader" style="width: 17%;">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h4>
                                <span *ngFor="let keyword of keywordContent"
                                    class="abstract-content justify-content text-color content-loader">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            </div>
                        </div>
                        <div class="row pt-2 pb-3" data-aos="fade-up"
                            *ngIf="!loading && articlelist.keywords && articlelist.keywords.length!==0" #keyword>
                            <div class="col-sm-12 col-md-12" data-aos="fade-up">
                                <h4 class="article-detail" tabindex="0"> {{'article_listing.keywords' | translate}}</h4>
                                <span *ngFor="let keyword of articlelist.keywords" tabindex="0"
                                    class="abstract-content activeComa justify-content text-color">{{keyword}}</span>
                            </div>
                        </div>
                        <div *ngIf="articleOutline.length === 0 && !loading && pdf_body_button" data-aos="fade-up"
                            class="d-flex justify-content-center">
                            <div class="pdf-viewer" (click)="viewPdf('pdf')" (keyup.enter)="viewPdf('pdf')"
                                (keyup.space)="viewPdf('pdf')" tabindex="0">
                                View the PDF for the full text of this article
                            </div>
                        </div>

                        <div id="pdfText" class="warn-container">
                            <span class="warn">{{pdfNotexist}}</span>
                        </div>


                        <div class="row pt-2 " data-aos="fade-up" *ngIf="loading">
                            <div class="col-sm-12 col-md-12" data-aos="fade-up">
                                <h4 class="article-detail content-loader" style="width: 17%;">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h4>
                                <span *ngFor="let keyword of keywordContent"
                                    class="abstract-content  justify-content text-color content-loader">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            </div>
                        </div>
                        <div class="row pt-2 " data-aos="fade-up"
                            *ngIf="!loading && articlelist.supplementary_files && articlelist.supplementary_files.length!==0"
                            id="supplementary-files" #keyword>
                            <div class="col-sm-12 col-md-12" data-aos="fade-up">
                                <h4 class="article-detail" tabindex="0">Supplementary Files</h4>
                                <ul
                                    class="abstract-content activeComa justify-content text-color supplementary_files-ul">
                                    <li *ngFor="let files of articlelist.supplementary_files; let i = index"
                                        class="supplementary_files-hover" [attr.data-rid]="files.id || 'S' + (i + 1)">
                                        <div class="d-flex justify-content" *ngIf="files.doi" >
                                            <div class="justify-content pr-1">
                                                {{files.title }}
                                            </div>
                                            <div class="justify-content">
                                                <a class="doi-underline" href="https://doi.org/{{files.doi}}"
                                                    target="_blank">({{files.doi }})</a>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content" *ngIf="!files.doi">
                                            <div class="justify-content pr-1 doi-underline" style="cursor: pointer;"
                                                role="button" tabindex="0"
                                                (click)="navigateToPdfView(files.file)"
                                                (keyup.enter)="navigateToPdfView(files.file)">
                                                {{files.title }}
                                            </div>
                                        </div>
                                    </li>
                                    <!-- <div class="d-flex justify-content">
                                        <div class="justify-content pr-2 supplementary_files-hover"> <fa-icon aria-hidden="true"
                                                (click)="navigateToPdfView(files.file)" [icon]="['fas', 'file-lines']">
                                            </fa-icon></div>
                                        <div class="justify-content pr-4 supplementary_files-hover" (click)="navigateToPdfView(files.file)">
                                            {{files.title }}</div>
                                        <div class="justify-content pr-2"> <fa-icon aria-hidden="true"
                                                title="{{ files.doi}}" [icon]="['fas', 'earth']">
                                            </fa-icon></div>
                                        <div class="justify-content pr-4 supplementary_files-hover"> <a class="link" target="_blank"
                                            title="{{ files.doi}}"
                                            href="https://doi.org/{{ files.doi}}">
                                            {{ files.doi}}</a></div> -->
                                    <!-- <div class="justify-content pr-2">  <fa-icon (click)="navigateToPdfView(files.file)"
                                            aria-hidden="true" title="View"
                                            [icon]="['fas', 'eye']">
                                        </fa-icon></div> -->

                                    <!-- </div> -->
                                </ul>
                            </div>
                        </div>
                        <div class="small-side-btn d-md-none d-lg-none d-xl-none d-xxl-none"
                            *ngIf="articleOutline && articleOutline.length >0" (click)="showArticleOutline()">
                            <span>
                                <fa-icon aria-hidden="true" class="pr-2" [icon]="['fas', 'list-ul']">
                                </fa-icon>
                                Article Outline
                            </span>
                            <span class="separation">
                                <fa-icon aria-hidden="true" [icon]="['fas', 'angle-down']" class="rotate-icon pl-2">
                                </fa-icon>
                            </span>
                        </div>

                        <div class="row pt-5 content-section">

                            <div #articleOutlinecol *ngIf="articleOutline && articleOutline.length >0"
                                id="article-outline" class=" col-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 pl-0">


                                <div #articleOutlin class="abstract-title-content {{tooltipStatus}}" data-aos="fade-up"
                                    *ngIf="articleOutline&& articleOutline.length >0">


                                    <h4 class="navigation-heading " tabindex="0" *ngIf="loading">
                                        <span class="nav-heading-content Outline content-loader">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </h4>
                                    <h4 class="navigation-heading" tabindex="0" *ngIf="!loading">
                                        <fa-icon class="iconcls citation-icon Outline Outlineicon" aria-hidden="true"
                                            [icon]="['fas', 'list-ul']">
                                        </fa-icon>
                                        <span class="nav-heading-content Outline">
                                            Article Outline
                                        </span>
                                    </h4>
                                    <div class="page-content pl-4 ml-1 page-container" id="page-content">
                                        <div class="row">
                                            <div *ngIf="loading" class="timeline block mb-4">
                                                <div class="tl-item"
                                                    *ngFor="let content of abstractcontentloader; let i = index">
                                                    <div class="tl-dot b-warning secondary">
                                                    </div>
                                                    <div class="tl-content secondary content-loader">
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="!loading &&  articleOutline && articleOutline.length >0"
                                                #articleHead class="timeline block mb-4">
                                                <div class="tl-item"
                                                    *ngFor="let content of articleOutline; let i = index">
                                                    <div class="tl-dot b-warning secondary"
                                                        [class.list-content]="activeline[i]">
                                                    </div>
                                                    <div id="outline{{content.outlineId}}" class="tl-content secondary"
                                                        [class.badge-content]="activeline[i]"
                                                        (click)="styleChange(i,content.outlineId)"
                                                        (keyup.enter)="styleChange(i,content.outlineId)"
                                                        (keyup.space)="styleChange(i,content.outlineId)" tabindex="0"
                                                        role="contentinfo">
                                                        {{content.title}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="articleViewContents"
                                *ngIf="!loading && articleOutline && articleOutline.length >0 "
                                class=" col-9 col-sm-12 col-md-9 col-lg-9 col-xl-9  col-xxl-9 z-index"
                                data-aos="fade-up" #articleViewContents>
                                <div #article id="article" class="article-contents {{authorStatus}}" tabindex="0"
                                    [innerHTML]="articleHtml | highlightSearch : ''" (click)="refClick($event)"
                                    (keyup.enter)="refClick($event)" (keyup.space)="refClick($event)" role="contentinfo"
                                    (mouseover)="showTooltip($event)" (mousemove)="leaveTooltip($event,'content')"
                                    (mouseleave)="leaveTooltip($event,'content')">
                                </div>
                            </div>
                            <div id="articleViewContents" *ngIf="!loading && articleOutline.length === 0"
                                class="col-12 z-index" data-aos="fade-up" #articleViewContents>
                                <div #article id="article" class="article-contents {{authorStatus}}" tabindex="0"
                                    [innerHTML]="articleHtml | highlightSearch : ''" (click)="refClick($event)"
                                    (keyup.enter)="refClick($event)" (keyup.space)="refClick($event)" role="contentinfo"
                                    (mouseover)="showTooltip($event)" (mousemove)="leaveTooltip($event,'content')"
                                    (mouseleave)="leaveTooltip($event,'content')">
                                </div>
                            </div>
                            <!-- <div #ImagesOutlin class="abstract-title-content {{tooltipStatus}}" data-aos="fade-up">
                            </div> -->
                        </div>
                    </div>

                </div>

                <div [ngClass]="expanded?'content':'col-sm-12  col-md-12 col-lg-3  col-xl-3 col-xxl-3 additional-btns'">

                    <div #articleViewBox class="article-view-box article-view-settings">
                        <div #listContent3 class="row mb-2">
                            <div class="col px-0">
                                <div class="icon-box content-loader" *ngIf="loading">
                                    <br>
                                    <br>
                                </div>
                                <div class="icon-box" *ngIf="!loading" (click)="downloadPdf('pdf')"
                                    (keyup.enter)="downloadPdf('pdf')" (keyup.space)="downloadPdf('pdf')" onclick="gtag('event', 'download', {
                                        'event_category': 'Downloads',
                                        'event_label': 'File.pdf'
                                    });" title="Download PDF">
                                    <fa-icon class="iconcls citation-icon black-icon icon-class" aria-hidden="true"
                                        *ngIf="!downloading" [icon]="['fas', 'cloud-arrow-down']"></fa-icon>
                                    <fa-icon class="iconcls citation-icon black-icon icon-class" *ngIf="downloading"
                                        [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
                                    <!-- <fa-icon class="iconcls citation-icon black-icon icon-class ps-1" aria-hidden="true"
                                        [icon]="['fas', 'file']"></fa-icon> -->
                                    <!-- <span class="pdf-xml-icon">pdf / xml</span> -->
                                    <!-- <div class="dropdown rvh-menu-label dropdown-download"
                                        (mouseenter)="openDropdown('download')"
                                        (mouseleave)="closeDropdown('download')"> -->
                                    <div class="dropdown rvh-menu-label dropdown-download" title="Download PDF">
                                        <!-- <a class="nav-link-primary heading" role="button" tabindex="0"
                                            aria-haspopup="listbox" id="dropdownMenuLinkMore" data-bs-toggle="dropdown"
                                            aria-expanded="false" 
                                            (click)="downloadPdf('pdf')"
                                            onclick="gtag('event', 'download_file', {
                                                'event_category': 'Downloads',
                                                'event_label': 'File.pdf'
                                            });"
                                            (keyup.enter)="downloadPdf('pdf')"
                                            (keyup.space)="downloadPdf('pdf')" title="Download PDF"> -->
                                        <!-- Download --> Download PDF
                                        <!-- </a> -->
                                        <ul role="list" class="dropdown-menu rvh-article-download-button"
                                            aria-labelledby="dropdownMenuLinkMore" aria-expanded="false"
                                            #dropdownMenuDownload>
                                            <li role="listitem">
                                                <a *ngIf="!disableBtnPdf" class="dropdown-item" tabindex="0"
                                                    role="button" (click)="downloadPdf('pdf')" onclick="gtag('event', 'download', {
                                                        'event_category': 'Downloads',
                                                        'event_label': 'File.pdf'
                                                    });" (keyup.enter)="downloadPdf('pdf')"
                                                    (keyup.space)="downloadPdf('pdf')" title="PDF Download">
                                                    <div class="download-container">
                                                        <div class="icon-container">
                                                            <fa-icon [icon]="['fas', 'download']"
                                                                class="iconcls"></fa-icon>
                                                        </div>
                                                        <div class="text-container">PDF</div>
                                                    </div>
                                                </a>
                                            </li>
                                            <li role="listitem">
                                                <a *ngIf="!disableBtnXml" class="dropdown-item" tabindex="0"
                                                    role="button" (click)="downloadPdf('xml')"
                                                    (keyup.enter)="downloadPdf('xml')"
                                                    (keyup.space)="downloadPdf('xml')" title="XML Download">
                                                    <div class="download-container">
                                                        <div class="icon-container">
                                                            <fa-icon [icon]="['fas', 'download']"
                                                                class="iconcls"></fa-icon>
                                                        </div>
                                                        <div class="text-container">XML</div>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col px-1">
                                <div class="icon-box content-loader" *ngIf="loading">
                                    <br>
                                    <br>
                                </div>
                                <div class="icon-box" *ngIf="!loading">
                                    <fa-icon class="iconcls citation-icon black-icon icon-class" aria-hidden="true"
                                        [icon]="['fas', 'share-nodes']"></fa-icon>
                                    <div class="dropdown rvh-menu-label dropdown-share"
                                        (mouseenter)="openDropdown('share')" (mouseleave)="closeDropdown('share')">

                                        <nav aria-label="Share options">
                                            <a role="button" aria-haspopup="listbox" id="dropdownMenuLinkShare"
                                                data-bs-toggle="dropdown" aria-expanded="false" tabindex="0"
                                                title="Share" class="dropdown-toggle nav-link-primary heading">
                                                Share
                                            </a>
                                            <!-- your dropdown menu here -->
                                        </nav>
                                        <ul role="list" class="dropdown-menu rvh-share-menu-dropdown "
                                            aria-labelledby="dropdownMenuLinkShare" aria-expanded="false"
                                            #dropdownMenuShare>
                                            <li role="listitem">
                                                <a class="dropdown-item me-1" tabindex="0" title="Linkedin">
                                                    <share-button button="linkedin" text="Linkedin" [showText]="true"
                                                        description="Sharing the article link"
                                                        [url]="'sharedUrl'"></share-button>
                                                </a>

                                            </li>
                                            <li role="listitem">
                                                <a class="dropdown-item me-1" tabindex="0" title="Tweet">
                                                    <share-button button="twitter" text="Tweet" [showText]="true"
                                                        [url]="'sharedUrl'"></share-button>
                                                </a>

                                            </li>
                                            <li role="listitem">
                                                <a class="dropdown-item me-1" tabindex="0" title="Facebook">
                                                    <share-button button="facebook" text="Facebook" [showText]="true"
                                                        [url]="'sharedUrl'"></share-button>
                                                </a>

                                            </li>
                                            <li role="listitem">
                                                <a class="dropdown-item me-1" tabindex="0" title="Email">
                                                    <share-button button="email" text="Email" [showText]="true"
                                                        description="Sharing the article link" [title]="titleShared"
                                                        [url]="'sharedUrl'"></share-button>
                                                </a>

                                            </li>
                                            <li role="listitem">
                                                <a class="dropdown-item me-1" tabindex="0" title="Copy Link">
                                                    <share-button button="copy" text="Copy Link" [showText]="true"
                                                        [url]="'sharedUrl'"></share-button>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col px-0">
                                <div class="icon-box content-loader" *ngIf="loading">
                                    <br>
                                    <br>
                                </div>
                                <div class="icon-box" *ngIf="!loading" (click)="viewCitetion()"
                                    title="Cite this article" (keyup.enter)="viewCitetion()" role="button"
                                    (keyup.space)="viewCitetion()" tabindex="0">
                                    <fa-icon class="iconcls citation-icon black-icon icon-class" aria-hidden="true"
                                        [icon]="['fas', 'quote-right']"></fa-icon>
                                    <div class="heading">Cite</div>
                                </div>
                            </div>
                            <div class="col px-1" *ngIf="showFavoritesBtn">
                                <div class="icon-box content-loader" *ngIf="loading">
                                    <br>
                                    <br>
                                </div>
                                <div class="icon-box" *ngIf="!loading " tabindex="0" (click)="addToFavourites()">
                                    <fa-icon *ngIf="!toggle_favourite"
                                        class="iconcls citation-icon black-icon icon-class" aria-hidden="true"
                                        [icon]="['far', 'star']"></fa-icon>
                                    <fa-icon *ngIf="toggle_favourite"
                                        class="iconcls citation-icon black-icon icon-class" aria-hidden="true"
                                        [icon]="['fas', 'star']"></fa-icon>
                                    <div class="heading">Favourites</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div #listContent2 class="col-12" *ngIf="citeModal===true">
                                <div class="card mt-3 {{authorStatus}}" data-aos="fade-up">
                                    <div
                                        class="card-header cite-background d-flex justify-content-between align-items-center">
                                        <div>
                                            <fa-icon class="iconcls citation-icon article-detail icon-class"
                                                aria-hidden="true" [icon]="['fas', 'quote-left']"></fa-icon>
                                            <span class="citation-heading secondary">Cite this article</span>
                                        </div>
                                        <button *ngIf="!isCopied" class="btn citation-button-content mt-3 me-3"
                                            (click)="copyToClipboard()" tabindex="0" ngbTooltip="Copied citation"
                                            tooltipClass="my-tooltip" triggers="click" autohide="true" delay="1">
                                            <fa-icon class="iconcls icon-class" aria-hidden="true"
                                                [icon]="['far', 'copy']"></fa-icon>
                                            {{'article_view._copy_citation' | translate}}
                                        </button>
                                        <button *ngIf="isCopied" class="btn citation-button-content mt-3 me-3"
                                            [@fadeInOut]>
                                            <fa-icon class="iconcls citation-button-success icon-class"
                                                aria-hidden="true" [icon]="['fas', 'check']"></fa-icon>
                                            {{'article_view.copied' | translate}}
                                        </button>
                                    </div>
                                    <div class="card-body">
                                        <p #citation class="text-color" tabindex="0"
                                            [innerHTML]="setCiteArticle(articlelist) | highlightSearch : ''"></p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 content-loader" style="padding: 0px;" *ngIf="loading">
                                <div style="width:100% ;height: 100%;padding-left: 25rem;">
                                    <br>
                                    <br> <br> <br><br>
                                    <br> <br> <br><br>
                                    <br> <br> <br><br>
                                    <br> <br> <br><br>
                                    <br> <br> <br><br> <br> <br><br>
                                    <br> <br> <br><br>
                                    <br> <br> <br>
                                </div>
                            </div>

                            <div class="col-12" style="padding: 0px;" *ngIf="!loading">
                                <ul #listContent1 class="nav nav-tabs pb-2" id="custom-tabs-three-tab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link" [ngClass]="{'active': activeTab === 'tab1'}"
                                            (click)="setActiveTab('tab1')" (keyup.enter)="setActiveTab('tab1')"
                                            (keyup.space)="setActiveTab('tab1')" aria-label="Article info" tabindex="0"
                                            title="Article info" role="tab" aria-selected="false" id="tab-1"
                                            aria-controls="panel-1">
                                            <fa-icon class="iconcls citation-icon-tab black-icon icon-class"
                                                aria-hidden="true" [icon]="['fas', 'circle-info']"></fa-icon>
                                            Article info</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link" [ngClass]="{'active': activeTab === 'tab2'}" tabindex="0"
                                            (click)="setActiveTab('tab2')" (keyup.enter)="setActiveTab('tab2')"
                                            (keyup.space)="setActiveTab('tab2')" aria-label="Metrics" title="Metrics"
                                            role="tab" aria-selected="false" id="tab-2" aria-controls="panel-2">
                                            <fa-icon class="iconcls citation-icon-tab black-icon icon-class"
                                                aria-hidden="true" [icon]="['fas', 'square-poll-vertical']"></fa-icon>
                                            Metrics</a>
                                    </li>
                                    <li class="nav-item" *ngIf="imagePaths.length!==0" role="presentation">
                                        <a class="nav-link" [ngClass]="{'active': activeTab === 'tab3'}" tabindex="0"
                                            (click)="setActiveTab('tab3')" role="tab" aria-selected="false" id="tab-3"
                                            aria-controls="panel-3" (keyup.enter)="setActiveTab('tab3')"
                                            (keyup.space)="setActiveTab('tab3')" title="Images">
                                            <fa-icon class="iconcls citation-icon-tab black-icon icon-class"
                                                aria-hidden="true" [icon]="['fas', 'images']"></fa-icon>
                                            Images <span>({{imagePaths.length}})</span></a>
                                    </li>
                                    <li class="nav-item" *ngIf="clipPaths.length!==0" role="presentation">
                                        <a class="nav-link" [ngClass]="{'active': activeTab === 'tab9'}" role="tab"
                                            aria-selected="false" id="tab-4" aria-controls="panel-4" tabindex="0"
                                            title="Clips" (click)="setActiveTab('tab9')"
                                            (keyup.enter)="setActiveTab('tab9')" (keyup.space)="setActiveTab('tab9')">
                                            <fa-icon class="iconcls citation-icon-tab black-icon icon-class"
                                                aria-hidden="true" [icon]="['fas', 'video']"></fa-icon>
                                            Clips <span>({{clipPaths.length}})</span></a>
                                    </li>
                                    <li class="nav-item" *ngIf=" tableOverview.length!==0" role="presentation">
                                        <a class="nav-link" [ngClass]="{'active': activeTab === 'tab4'}" tabindex="0"
                                            title="Tables" (click)="setActiveTab('tab4')" role="tab"
                                            aria-selected="false" id="tab-5" aria-controls="panel-5"
                                            (keyup.enter)="setActiveTab('tab4')" (keyup.space)="setActiveTab('tab4')">
                                            <fa-icon class="iconcls citation-icon-tab black-icon icon-class"
                                                aria-hidden="true" [icon]="['fas', 'table-cells']"></fa-icon>
                                            Tables <span
                                                *ngIf=" tableOverview.length!==0">({{tableOverview.length}})</span>
                                        </a>
                                    </li>
                                    <!-- <li class="nav-item" role="presentation">
                                        <a class="nav-link" [ngClass]="{'active': activeTab === 'tab5'}"  tabindex="0" aria-label="Timeline"
                                            (click)="setActiveTab('tab5')"  (keyup.enter)="setActiveTab('tab5')" (keyup.space)="setActiveTab('tab5')"  role="tab"  aria-selected="false" id="tab-6" 
                                    aria-controls="panel-6">
                                            <fa-icon class="iconcls citation-icon-tab black-icon" aria-hidden="true"
                                                [icon]="['fas', 'clock-rotate-left']"></fa-icon>
                                            Timeline</a>
                                    </li> -->
                                    <li class="nav-item" *ngIf="articlesData.articles.length > 0" role="presentation">
                                        <a class="nav-link" [ngClass]="{'active': activeTab === 'tab6'}" tabindex="0"
                                            (click)="setActiveTab('tab6')" role="tab" aria-selected="false" id="tab-7"
                                            aria-controls="panel-7" (keyup.enter)="setActiveTab('tab6')"
                                            (keyup.space)="setActiveTab('tab6')" title="Related articles">
                                            <fa-icon class="iconcls citation-icon-tab black-icon icon-class"
                                                aria-hidden="true" [icon]="['fas', 'link']"></fa-icon>
                                            Related Articles <span>({{articlesData.articles.length}})</span></a>
                                    </li>
                                    <li class="nav-item mb-2" *ngIf="articlelist.supplementary_files.length!==0"
                                        role="presentation">
                                        <a class="nav-link" [ngClass]="{'active': activeTab === 'tab7'}" tabindex="0"
                                            (click)="setActiveTab('tab7')" role="tab" aria-selected="false" id="tab-8"
                                            aria-controls="panel-8" (keyup.enter)="setActiveTab('tab7')"
                                            (keyup.space)="setActiveTab('tab7')" title="Supplementary files">
                                            <fa-icon class="iconcls citation-icon-tab black-icon icon-class"
                                                aria-hidden="true" [icon]="['far', 'copy']"></fa-icon>
                                            Supplementary Files <span>
                                                ({{articlelist.supplementary_files.length}})</span></a>
                                    </li>
                                    <li class="nav-item mb-2" role="presentation">
                                        <a class="nav-link" [ngClass]="{'active': activeTab === 'tab8'}" tabindex="0"
                                            aria-label="References" (click)="setActiveTab('tab8')" role="tab"
                                            aria-selected="false" id="tab-9" aria-controls="panel-9"
                                            (keyup.enter)="setActiveTab('tab8')" (keyup.space)="setActiveTab('tab8')"
                                            title="References">
                                            <fa-icon class="iconcls citation-icon-tab black-icon icon-class"
                                                aria-hidden="true" [icon]="['far', 'copy']"></fa-icon>
                                            References</a>
                                    </li>
                                </ul>

                                <div #myTabContent id="custom-tabs-three-tab-tabContent" class="myTabContent">
                                    <div *ngIf="!articlelist?.doi" class="tab-panes pb-2"
                                        [hidden]="activeTab !== 'tab1'">
                                        <div *ngIf="!articlelist?.doi" appRenderHtml></div>
                                        <ng-container *ngIf="!articlelist?.doi">
                                            <div class="card">
                                                <div class="card-body text-align-center">
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center;">
                                                        <img width="20" height="20" class="no-data-found-img"
                                                            src="assets/images/not_found_img/no_data_1.webp" alt="">
                                                        <h5 class="card-title text-head-size">No Data
                                                            Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="tab-panes pb-2" [hidden]="activeTab !== 'tab1'" id="panel-1"
                                        aria-labelledby="tab-1" role="contentinfo">
                                        <!-- Content for Tab 1 -->
                                        <div class="pb-2" *ngIf="articlelist?.doi">
                                            <span class="tab-content-heading">DOI: </span>
                                            <span class="tab-content-value"><a class="link" target="_blank"
                                                    title="https://doi.org/{{articlelist.doi}}" class="doi-underline"
                                                    href="https://doi.org/{{articlelist.doi}}">
                                                    {{articlelist.doi}}</a></span>
                                        </div>
                                        <div class="pb-2" *ngIf="articlelist?.published_date">
                                            <span class="tab-content-heading">Published on: </span>
                                            <span class="tab-content-value">
                                                {{articlelist.published_date}}</span>
                                        </div>
                                        <div class="pb-2" *ngIf="articlelist?.volume_id">
                                            <span class="tab-content-heading">Volume: </span>
                                            <span class="tab-content-value">
                                                {{articlelist.volume_id}}</span>
                                        </div>
                                        <div class="pb-2"
                                            *ngIf="articlelist?.issue_id && articlelist?.issue_id!=='non-issue'">
                                            <span class="tab-content-heading">Issue: </span>
                                            <span class="tab-content-value">
                                                {{changeIssue(articlelist.issue_id)}}</span>
                                        </div>
                                        <!-- <div class="pb-2" *ngIf="articlelist?.article_id">
                                            <span class="tab-content-heading">Article ID:</span>
                                            <span class="tab-content-value">
                                                {{articlelist.article_id}}</span>
                                            </div> -->
                                        <div class="pb-2" *ngIf="articlelist?.article_id">
                                            <span class="tab-content-heading">Article view count:</span>
                                            <span class="tab-content-value">
                                                {{articlelist.view_count}}</span>
                                        </div>
                                        <div class="pb-2" *ngIf="articlelist?.article_id">
                                            <span class="tab-content-heading">Article download count:</span>
                                            <span class="tab-content-value">
                                                {{articlelist.download_count}}</span>
                                        </div>
                                        <div class="pb-2" *ngIf="setPageNumber(articlelist.fpage,articlelist.lpage)">
                                            <span class="tab-content-heading">Pages:</span>
                                            <span class="tab-content-value"
                                                [innerHTML]="setPageNumber(articlelist.fpage,articlelist.lpage)">
                                            </span>
                                        </div>
                                        <!-- <div class="pb-2" *ngIf="articlelist?.e_issn">
                                            <span class="tab-content-heading">EBook (PDF) ISSN:</span>
                                            <span class="tab-content-value">{{articlelist.e_issn}}
                                            </span>
                                        </div> -->

                                        <div class="tab-panes pb-4 block-content mt-3"
                                            *ngIf="articlelist?.copyright_statement">
                                            <!-- Content for Tab 1 -->
                                            <h5 class="block-content-heading"> <fa-icon
                                                    class=" iconcls citation-icon-tab black-icon icon-class"
                                                    aria-hidden="true" [icon]="['fas', 'copyright']"></fa-icon>
                                                Copyright statement </h5>
                                            <span class="block-content-value">{{articlelist.copyright_statement}}
                                            </span>
                                            <span class="block-content-value"
                                                [innerHtml]="structuringData(articlelist.license)"></span>
                                        </div>

                                        <div class="tab-panes pb-4 block-content mt-3"
                                            *ngIf="setCiteArticle(articlelist)">
                                            <!-- Content for Tab 1 -->
                                            <h5 class="block-content-heading"> <fa-icon
                                                    class="iconcls citation-icon-tab black-icon icon-class"
                                                    aria-hidden="true" [icon]="['fas', 'quote-left']"></fa-icon>
                                                Cite this article
                                            </h5>
                                            <span class="block-content-value"
                                                [innerHTML]="setCiteArticle(articlelist) | highlightSearch : ''">
                                            </span>
                                        </div>
                                    </div>

                                    <div class="tab-panes" [hidden]="activeTab !== 'tab2'">
                                        <!-- <div class="row"> -->
                                        <ng-container *ngIf="false">
                                            <div class="card">
                                                <div class="card-body text-align-center">
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center;">
                                                        <img width="20" height="20" class="no-data-found-img"
                                                            src="assets/images/not_found_img/no_data_1.webp" alt="">
                                                        <h5 class="card-title  text-head-size">No Data
                                                            Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container>
                                            <!-- <div class="row">
                                                <p class="crossref">Crossref</p>
                                                <a data-target="crossmark"><img
                                                        src="https://crossmark-cdn.crossref.org/widget/v2.0/logos/CROSSMARK_Color_horizontal.svg"
                                                        width="150" /></a>
                                            </div> -->

                                            <div class="row mb-3" *ngIf="articlelist.doi">
                                                <p class="crossref">Crossref</p>
                                                <a class="crossmark" data-target="crossmark"
                                                    [attr.data-doi]="articlelist.doi" (click)="openCrossmark()"
                                                    (keyup.enter)="openCrossmark()" tabindex="0"
                                                    style="cursor: pointer;">
                                                    <img src="https://crossmark-cdn.crossref.org/widget/v2.0/logos/CROSSMARK_Color_horizontal.svg"
                                                        width="150" />
                                                </a>

                                            </div>

                                            <div class="row" #dimensionDiv *ngIf="articlelist.doi">
                                                <p class="dimension">Dimensions</p>
                                                <span class="__dimensions_badge_embed__"
                                                    [attr.data-doi]="articlelist.doi" data-legend="always"
                                                    data-style="medium_circle"></span>

                                                <!-- <span class="__dimensions_badge_embed__" data-doi="10.1038/nplants.2015.7"></span> -->
                                            </div>

                                            <!-- for altmetrics -->
                                            <div class="row mb-3" *ngIf="articlelist.doi">
                                                <p class="dimension">Altmetric</p>
                                                <!-- Altmetric Badge -->

                                                <div data-badge-type="donut" class='altmetric-embed'
                                                    data-badge-popover='right' [attr.data-doi]="articlelist.doi">
                                                </div>

                                            </div>
                                            <!-- <div class="row"> 
                                                <span class="scite-badge" aria-hidden="true" data-doi="10.1016/j.biopsych.2005.08.012"
                                                    data-tally-show='false' data-section-tally-show='true'
                                                    data-show-labels='true' data-tooltip-placement="left"
                                                    data-small="true" data-show-zero="false" data-show-labels="true"
                                                    data-section-tally-layout='vertical' data-chart-type='donut'
                                                    (mouseover)="removeZIndex()" (mouseleave)="addZIndex()"></span>
                                            </div> -->
                                            <div class="row">
                                                <div>
                                                    <p class="dimension">Article metrics</p>
                                                    <p style="margin-top: -12px;" class="view-count"><fa-icon
                                                            class="iconcls icon-class pr-2" aria-hidden="true"
                                                            [icon]="['fas', 'eye']">
                                                        </fa-icon>View count: {{articlelist.view_count}}
                                                    </p>
                                                    <p style="margin-top: -5px;" class="download-count"><fa-icon
                                                            class="iconcls pr-2" aria-hidden="true"
                                                            [icon]="['fas', 'download']">
                                                        </fa-icon>Download count: {{articlelist.download_count}}
                                                    </p>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <!-- </div> -->
                                    </div>
                                    <div class="tab-panes" [hidden]="activeTab !== 'tab3'">
                                        <ng-container *ngIf="imagePaths.length===0">
                                            <div class="card">
                                                <div class="card-body text-align-center">
                                                    <!--<h5 class="card-title text-head-size">No Data Found</h5>
                                                    <p class="card-text">There is no data available for this
                                                        tab.</p> -->
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center;">
                                                        <img width="20" height="20" class="no-data-found-img"
                                                            src="assets/images/not_found_img/no_data_1.webp" alt="">
                                                        <h5 class="card-titletext-head-size">No Data
                                                            Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="imagePaths.length!==0">
                                            <h4 *ngIf="imagePaths.length!==0" class="navigation-heading-1" tabindex="0">
                                                <fa-icon class="iconcls citation-icon Outline Outlineicon"
                                                    aria-hidden="true" [icon]="['fas', 'images']">
                                                </fa-icon>
                                                <span class="nav-heading-content Outline">
                                                    Images Outline
                                                </span>
                                            </h4>
                                            <div *ngIf="imagePaths.length!==0 " class="page-content pl-4 page-container"
                                                id="page-content">
                                                <div class="row">
                                                    <div class="col-4 pb-3"
                                                        *ngFor="let content of imagePaths; let i = index">
                                                        <img width="20" height="20" class="graphic"
                                                            (click)="imgStyleChange(content.srcValue)"
                                                            attr-position="float" attr-orientation="portrait"
                                                            src={{content.imageUrl}}>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="imagePaths.length===0" class=" page-content pl-4 page-container"
                                                id="page-content">
                                                <div class="row">
                                                    <div class="col">
                                                        <div
                                                            style="display: flex; flex-direction: column; align-items: center; padding-bottom: 5px;">
                                                            <img width="20" height="20" class="no-data-found-img"
                                                                src="assets/images/not_found_img/no_data_1.webp" alt="">
                                                            <h5 class="card-title  text-head-size">
                                                                No Data found</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="tab-panes" [hidden]="activeTab !== 'tab9'">
                                        <ng-container *ngIf="clipPaths.length===0">
                                            <div class="card">
                                                <div class="card-body text-align-center">
                                                    <!--<h5 class="card-title text-head-size">No Data Found</h5>
                                                    <p class="card-text">There is no data available for this
                                                        tab.</p> -->
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center;">
                                                        <img width="20" height="20" class="no-data-found-img"
                                                            src="assets/images/no_data_1.webp" alt="">
                                                        <h5 class="card-title text-head-size">No Data
                                                            Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="clipPaths.length!==0">
                                            <h4 *ngIf="clipPaths.length!==0" class="navigation-heading-1" tabindex="0">
                                                <fa-icon class="iconcls citation-icon Outline Outlineicon"
                                                    aria-hidden="true" [icon]="['fas', 'images']">
                                                </fa-icon>
                                                <span class="nav-heading-content Outline">
                                                    Videos Outline
                                                </span>
                                            </h4>
                                            <div *ngIf="clipPaths.length!==0 " class="page-content pl-4 page-container"
                                                id="page-content">
                                                <div class="row">
                                                    <div class="col-4 pb-3"
                                                        *ngFor="let content of clipPaths; let i = index">
                                                        <img width="20" height="20" class="graphic"
                                                            (click)="imgStyleChange(content.srcValue)"
                                                            attr-position="float" attr-orientation="portrait"
                                                            src={{content.imageUrl}}>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="clipPaths.length===0" class=" page-content pl-4 page-container"
                                                id="page-content">
                                                <div class="row">
                                                    <div class="col">
                                                        <div
                                                            style="display: flex; flex-direction: column; align-items: center; padding-bottom: 5px;">
                                                            <img width="20" height="20" class="no-data-found-img"
                                                                src="assets/images/not_found_img/.png" alt="">
                                                            <h5 class="card-title text-head-size">
                                                                No Data found</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="tab-panes" [hidden]="activeTab !== 'tab4'">
                                        <ng-container *ngIf="!tableOverview">
                                            <div class="card">
                                                <div class="card-body text-align-center">
                                                    <!--<h5 class="card-title text-head-size">No Data Found</h5>
                                                    <p class="card-text">There is no data available for this
                                                        tab.</p> -->
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center;">
                                                        <img width="20" height="20" class="no-data-found-img"
                                                            src="assets/images/no_data_1.webp" alt="">
                                                        <h5 class="card-title  text-head-size">No Data
                                                            Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="tableOverview">
                                            <h4 class="navigation-heading-1" tabindex="0">
                                                <fa-icon class="iconcls citation-icon Outline Outlineicon"
                                                    aria-hidden="true" [icon]="['fas', 'table-cells']">
                                                </fa-icon>
                                                <span class="nav-heading-content Outline">
                                                    Tables Outline
                                                </span>
                                            </h4>
                                            <div class="page-content pl-4 page-container" id="page-content">
                                                <div class="row" *ngFor="let content of tableOverview; let i = index">
                                                    <div class="col-12 pb-3 table-contet-div"
                                                        (click)="navigateToTable(content.tableId)"
                                                        (keyup.enter)="navigateToTable(content.tableId)"
                                                        (keyup.space)="navigateToTable(content.tableId)">
                                                        <div class="table-count"><fa-icon
                                                                class="iconcls citation-icon Outline Outlineicon"
                                                                aria-hidden="true" [icon]="['fas', 'table']">
                                                            </fa-icon> {{content.tableCount}}</div>
                                                        <div class="table-title">{{content.tableTitle}}</div>
                                                    </div>
                                                </div>
                                                <div class="row" *ngIf=" tableOverview.length===0">
                                                    <div class="col-12 pb-3 table-contet-div">
                                                        <div
                                                            style="display: flex; flex-direction: column; align-items: center;">
                                                            <img width="20" height="20" class="no-data-found-img"
                                                                src="assets/images/not_found_img/no_data_1.webp" alt="">
                                                            <h5 class="card-title text-head-size">No Data
                                                                Found</h5>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="tab-panes" [hidden]="activeTab !== 'tab5'">
                                        <ng-container *ngIf="!timelineEvents">
                                            <div class="card">
                                                <div class="card-body text-align-center">
                                                    <!--<h5 class="card-title text-head-size">No Data Found</h5>
                                                    <p class="card-text">There is no data available for this
                                                        tab.</p> -->
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center;">
                                                        <img width="20" height="20" class="no-data-found-img"
                                                            src="assets/images/no_data_1.webp" alt="">
                                                        <h5 class="card-title text-head-size">No Data
                                                            Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="timelineEvents">
                                            <h4 class="navigation-heading-1" tabindex="0">
                                                <fa-icon class="iconcls citation-icon Outline Outlineicon"
                                                    aria-hidden="true" [icon]="['fas', 'clock-rotate-left']">
                                                </fa-icon>
                                                <span class="nav-heading-content Outline">
                                                    Article timeline
                                                </span>
                                            </h4>
                                            <div style="width: 80%;">
                                                <div class="time-line-item date-timeline"
                                                    *ngFor="let content of timelineEvents; let i = index">
                                                    <div id="content.date"
                                                        class="time-line-content secondary date-timeline"
                                                        style="text-align: right; height: 4rem;">
                                                        {{content.description}}
                                                    </div>
                                                    <div class="tl-dot b-warning secondary">
                                                    </div>
                                                    <div id="outline{{content.outlineId}}"
                                                        class="time-line-content secondary"
                                                        style="font-family: 'Tiempos-Text-Regular';" tabindex="0">
                                                        {{ content.date }}
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="tab-panes" [hidden]="activeTab !== 'tab6'">
                                        <div class="row">
                                            <h4 class="navigation-heading-1" tabindex="0">
                                                <fa-icon class="iconcls citation-icon Outline Outlineicon"
                                                    aria-hidden="true" [icon]="['fas', 'link']">
                                                </fa-icon>
                                                <span class="nav-heading-content Outline">
                                                    Related Articles
                                                </span>
                                            </h4>

                                            <div *ngIf="articlesData.articles.length > 0; else noRelatedArticles">
                                                <div class="row total-content"
                                                    *ngFor="let article of articlesData.articles let i = index">
                                                    <!-- <div class="col-md-6 total"
                                                    *ngFor="let article of articlesData.articles.slice(0, initialArticleCount); let i = index"> -->
                                                    <div *ngIf="!showLessFlagTab && i<2" class="article-box-second">
                                                        <!-- Image, Title, and Content for the first article -->
                                                        <div class="article-info-second">
                                                            <div class="row">

                                                                <div class="col-md-12">
                                                                    <a [routerLink]="['/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]"
                                                                        class="second-title"
                                                                        title="getCleanTitle(article.article_title)">{{
                                                                        getCleanTitle(article.article_title)}}</a>
                                                                    <a class="sub-title">

                                                                        <span class="line-clamp-2"
                                                                            title="{{getAuthorNames(article.authors)}}">
                                                                            {{getAuthorNames(article.authors) }}
                                                                        </span>
                                                                    </a>
                                                                    <p class="explore-content-second">
                                                                        {{article.abstract }}

                                                                    </p>
                                                                    <div class="row mt-1 mb-0">
                                                                        <div class="col-6">
                                                                            <a class="link" target="_blank"
                                                                                title="https://doi.org/{{article.doi}}"
                                                                                href="https://doi.org/{{article.doi}}"
                                                                                class="article-doi doi-content-1 doi-underline">
                                                                                <fa-icon class="iconcls"
                                                                                    aria-hidden="true"
                                                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                                                {{ article.doi
                                                                                }}
                                                                            </a>
                                                                        </div>
                                                                        <div class="col-6 text-end">
                                                                            <span class="article-doi doi-content-1">
                                                                                <fa-icon class="iconcls"
                                                                                    aria-hidden="true"
                                                                                    [icon]="['fas', 'calendar-days']"></fa-icon>
                                                                                {{ article.pub_date.day }} {{
                                                                                monthName(article.pub_date.month)
                                                                                }} {{ article.pub_date.year }}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div *ngIf="showLessFlagTab" class="article-box-second">
                                                        <!-- Image, Title, and Content for the first article -->
                                                        <div class="article-info-second">
                                                            <div class="row">

                                                                <div class="col-md-12">
                                                                    <a [routerLink]="['/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]"
                                                                        class="second-title"
                                                                        title="{{article.article_title}}">{{
                                                                        getCleanTitle(article.article_title) }}</a>
                                                                    <a class="sub-title">

                                                                        <span class="line-clamp-2"
                                                                            title="{{getAuthorNames(article.authors)}}">
                                                                            {{getAuthorNames(article.authors) }}
                                                                        </span>
                                                                    </a>
                                                                    <p class="explore-content-second">
                                                                        {{article.abstract }}

                                                                    </p>
                                                                    <div class="row mt-1 mb-0">
                                                                        <div class="col-6">
                                                                            <a class="link" target="_blank"
                                                                                title="https://doi.org/{{article.doi}}"
                                                                                href="https://doi.org/{{article.doi}}"
                                                                                class="article-doi doi-content-1 doi-underline">
                                                                                <fa-icon class="iconcls"
                                                                                    aria-hidden="true"
                                                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                                                {{ article.doi
                                                                                }}
                                                                            </a>
                                                                        </div>
                                                                        <div class="col-6 text-end">
                                                                            <span class="article-doi doi-content-1">
                                                                                <fa-icon class="iconcls"
                                                                                    aria-hidden="true"
                                                                                    [icon]="['fas', 'calendar-days']"></fa-icon>
                                                                                {{ article.pub_date.day }} {{
                                                                                monthName(article.pub_date.month)
                                                                                }} {{ article.pub_date.year }}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <!-- </div> -->
                                                </div>
                                                <!--load button-->
                                                <div *ngIf="!loading && intialarticleCountInTab < totalArticles && !showLessFlagTab && !loadMoreFlagTab"
                                                    (click)="loadMoreArticles('tab_view')"
                                                    class="d-flex justify-content-center pt-2 pb-2">
                                                    <a class="explore-button-tab" title="Load more">
                                                        <span class="icon">

                                                        </span> Load More
                                                    </a>
                                                </div>
                                                <!--class="d-flex justify-content-center"-->
                                                <div *ngIf="!loading && showLessFlagTab && (totalArticles > intialarticleCountInTab || !loadMoreFlagTab)"
                                                    class="d-flex justify-content-center pt-2 pb-2"
                                                    (click)="showLessArticles('tab_view')">
                                                    <a class="explore-button-tab" title="Show less">
                                                        <span class="icon">

                                                        </span> Show less
                                                    </a>
                                                </div>
                                            </div>
                                            <ng-template #noRelatedArticles>
                                                <div class="card">
                                                    <div class="card-body text-align-center">
                                                        <!--<h5 class="card-title text-head-size">No Data Found</h5>
                                                        <p class="card-text">There is no data available for this
                                                            tab.</p> -->
                                                        <div
                                                            style="display: flex; flex-direction: column; align-items: center;">
                                                            <img width="20" height="20" class="no-data-found-img"
                                                                src="assets/images/not_found_img/no_data_1.webp" alt="">
                                                            <h5 class="card-title text-head-size">No Data
                                                                Found</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </div>
                                    </div>
                                    <div class="tab-panes" [hidden]="activeTab !== 'tab7'">
                                        <ng-container *ngIf="articlelist.supplementary_files.length===0">
                                            <div class="card">
                                                <div class="card-body text-align-center">
                                                    <!--<h5 class="card-title text-head-size">No Data Found</h5>
                                                    <p class="card-text">There is no data available for this
                                                        tab.</p> -->
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center;">
                                                        <img width="20" height="20" class="no-data-found-img"
                                                            src="assets/images/not_found_img/no_data_1.webp" alt="">
                                                        <h5 class="card-title text-head-size">No Data
                                                            Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="articlelist.supplementary_files.length!==0">
                                            <div class="card"
                                                *ngFor="let supplementary of articlelist.supplementary_files; let i = index">
                                                <div class="card-body text-align-center">
                                                    <!--<h5 class="card-title text-head-size">No Data Found</h5>
                                                    <p class="card-text">There is no data available for this
                                                        tab.</p> -->
                                                    <div class="row" [class.align-items-center]="!supplementary.doi">
                                                        <div class="col-1">
                                                            <div class=" justify-content-start pr-2">
                                                                <fa-icon class="supplementary-icon" aria-hidden="true"
                                                                    (click)="navigateToPdfView(supplementary.file)"
                                                                    [icon]="['fas', 'file-lines']">
                                                                </fa-icon>
                                                            </div>
                                                        </div>
                                                        <div class="col-9 pl-4">
                                                            <div class="d-flex justify-content "
                                                                style="cursor: pointer;"
                                                                (click)="navigateToPdfView(supplementary.file)"
                                                                title="{{  supplementary.title}}">
                                                                <div
                                                                    class="supplementary-title justify-content-start pb-1 block-content-heading">
                                                                    {{ supplementary.title}}
                                                                </div>
                                                            </div>
                                                            <div class="d-flex justify-content block-content-value"
                                                                *ngIf="supplementary.doi">
                                                                <div class="justify-content pr-2">
                                                                    <fa-icon aria-hidden="true"
                                                                        title="{{ supplementary.doi}}"
                                                                        [icon]="['fas', 'earth']">
                                                                    </fa-icon>
                                                                </div>
                                                                <div class=" justify-content-start">
                                                                    <a class="link" target="_blank"
                                                                        style="word-break: break-word;"
                                                                        title="https://doi.org/{{ supplementary.doi}}"
                                                                        class="doi-underline"
                                                                        href="https://doi.org/{{ supplementary.doi}}">
                                                                        {{ supplementary.doi}}
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-2 pb-0 justify-content-end">
                                                            <button class="form-control article-view-btn"
                                                                title="view file">
                                                                <fa-icon (click)="navigateToPdfView(supplementary.file)"
                                                                    aria-hidden="true" title="View" class="icon-class"
                                                                    [icon]="['fas', 'eye']">
                                                                </fa-icon>
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="tab-panes" [hidden]="activeTab !== 'tab8'">
                                        <ng-container *ngIf="!referenceData">
                                            <div class="card">
                                                <div class="card-body text-align-center">
                                                    <!--<h5 class="card-title text-head-size">No Data Found</h5>
                                                    <p class="card-text">There is no data available for this
                                                        tab.</p> -->
                                                    <div
                                                        style="display: flex; flex-direction: column; align-items: center;">
                                                        <img width="20" height="20" class="no-data-found-img"
                                                            src="assets/images/not_found_img/no_data_1.webp" alt="">
                                                        <h5 class="card-title text-head-size">No Data
                                                            Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="referenceData">
                                            <div class="card">
                                                <div class="card-body text-align-center">
                                                    <div class="ref-content" (click)="refOutlineClick($event)"
                                                        (keyup.enter)="refOutlineClick($event)"
                                                        (keyup.space)="refOutlineClick($event)"
                                                        [innerHTML]="referenceData.innerHTML"></div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="side-menu">
                    <div class="btn btn-rounded btn-primary new-btn " >
                        <fa-icon [icon]="['fas','angle-right']"></fa-icon>
                    </div>
                </div> -->
            </div>
        </div>
    </section>
</main>
<ng-template #modalData let-modal>
    <div *ngIf="!imageModal" class="modal-body modalfam">
        <div class="modal-header">
            <button type="button btnModal" class="close close-mdl-btn" data-dismiss="modal" (click)="modalClose()"
                (keyup.enter)="modalClose()" (keyup.space)="modalClose()" tabindex="0" aria-label="Close">
                <span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-header" style="display:block;" *ngIf="heading!==''">
            <div class="d-flex d-flex justify-content fig-modal">
                <div class="head-content">
                    <div class="" id="gigabyte001-g0005" attr-position="float" attr-orientation="portrait">
                        <div class="label">{{heading}}</div>
                        <div class="caption">
                            <div class="p">{{caption}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-body" [innerHTML]="body">
        </div>
    </div>
    <div *ngIf="imageModal" class="modal-body modalfam">
        <button type="button btnModal" class="close close-mdl-btn" data-dismiss="modal" (click)="modalClose()"
            (keyup.enter)="modalClose()" (keyup.space)="modalClose()" tabindex="0" aria-label="Close">
            <span aria-hidden="true">&times;</span></button>
        <div class="modal-header" style="display:block;">
            <div class="d-flex d-flex justify-content fig-modal">
                <div class="head-content">
                    <div class="" id="gigabyte001-g0005" attr-position="float" attr-orientation="portrait">
                        <div class="label">{{modalHrefContent}}</div>
                        <div class="caption">
                            <div class="p">{{modalContent}}</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="modal-body">
            <img width="200" height="200" class="graphic" attr-position="float" attr-orientation="portrait"
                src={{modalcurrentSrc}}>
        </div>
    </div>

</ng-template>


<!--realted articles-->

<section id="bottom-div" #bottomSection class="section-style bottom-div-section-style">
    <div class="container-fluid" *ngIf="articlesData.articles.length>0">
        <div class=" article-search-card w-100" data-aos="fade-up">


            <div class="section-title">
                <h2 *ngIf="loading" class=" primary pt-4">
                    <span class="content-loader section-title">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </h2>
                <h2 *ngIf="!loading" class="primary pt-4">{{ 'article.related_articles' | translate }}</h2>
            </div>
            <div class="row" *ngIf="loading">
                <div class="col-sm-12 col-md-6 total col-lg-4 col-xl-4 col-xxxl-4"
                    *ngFor="let article of recentArticles; let i = index">
                    <div class="article-box-second">
                        <!-- Image, Title, and Content for the first article -->
                        <div class="article-info-second">
                            <div class="row">
                                <div class="col-md-4">
                                    <img class="article-explore-image content-loader" style="    width: 11rem;
                                                height: 12rem;" alt="Cover image loading">

                                </div>
                                <div class="col-md-8">
                                    <h3 class="second-title">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3>

                                    <h4 class="sub-title">

                                        <span class="line-clamp-2 content-loader">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                        <span class="line-clamp-2">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    </h4>
                                    <div class="explore-content-second  content-loader about-content"
                                        *ngFor="let item of abstractcontentloader; let i = index">
                                    </div>
                                    <div class="row mt-5 mb-0">
                                        <div class="col-md-6">
                                            <span class="article-doi">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </div>
                                        <div class="col-md-6 text-end">
                                            <span class="article-doi">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row related-article-size" *ngIf="!loading">
                <div [ngClass]="!showLessFlag?'col-sm-12 col-md-6 total col-lg-6 col-xl-6 col-xxxl-6 mx-auto d-flex justify-content-center':'col-sm-12 total d-flex justify-content-center col-md-12 col-lg-6 col-xl-4 col-xxxl-4'"
                    *ngFor="let article of articlesData.articles let i = index">
                    <div class="article-box-second-1" *ngIf="i<2 && !showLessFlag">
                        <!-- Image, Title, and Content for the first article -->
                        <div class="article-info-second-1">
                            <div class="row">
                                <div class="col-md-4">
                                    <img width="20" height="20" class="article-explore-image"
                                        *ngIf="article.article_cover_image"
                                        src="{{articleCoverImageUrl+getRelatedArticleImageUrl(article)}}"
                                        alt="Cover image for the article">
                                    <img width="20" height="20" tabindex="0"
                                        *ngIf=" !article.article_cover_image && +article.volume <= 11"
                                        class="card-img-top rvh-article-default-cover"
                                        src="{{default_article_cover_image_upto_11}}" alt="Cover image for the article">
                                    <img width="20" height="20" tabindex="0"
                                        *ngIf=" !article.article_cover_image && +article.volume >11"
                                        class="card-img-top rvh-article-default-cover-green"
                                        src="{{default_article_cover_image_above_11}}"
                                        alt="Cover image for the article">
                                </div>
                                <div class="col-md-8">
                                    <a class="second-title" title="{{article.article_title}}"
                                        [routerLink]="['/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]"
                                        [innerHtml]="article.article_title"></a>

                                    <h3 class="sub-title-1">
                                        <!-- Loop through authors and display them with commas-->
                                        <!-- <ng-container *ngFor="let author of article.authors; let j = index">
                                                                            {{ author.given_name }} {{ author.surname }}{{ j <
                                                                                article.authors.length - 1 ? ', ' : '' }} </ng-container> -->

                                        <span class="line-clamp-2" title="{{getAuthorNames(article.authors)}}"
                                            [innerHtml]="getAuthorNames(article.authors)">
                                        </span>
                                    </h3>
                                    <p class="explore-content-second-1" [innerHtml]="article.abstract">

                                    </p>
                                    <div class="row mt-2 mb-0" style="font-size: 16px;">
                                        <div
                                            [ngClass]="!showLessFlag?'col-sm-6 col-md-12 col-lg-6 col-xl-6 col-xxl-6':'col-sm-12  col-md-6 col-lg-6 col-xl-6 col-xxxl-6'">
                                            <a class="link" target="_blank" title="https://doi.org/{{article.doi}}"
                                                href="https://doi.org/{{article.doi}}"
                                                class="article-doi doi-content-1 doi-underline">
                                                <fa-icon class="iconcls" aria-hidden="true"
                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                {{ article.doi
                                                }}
                                            </a>
                                        </div>
                                        <div
                                            [ngClass]="!showLessFlag?'col-sm-6 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-end':'col-sm-12  col-md-6 col-lg-6 col-xl-6 col-xxxl-6 text-end'">
                                            <span class="article-doi doi-content" title="{{ article.pub_date.day }} {{
                                                monthName(article.pub_date.month)
                                                }} {{ article.pub_date.year }}">
                                                <fa-icon class="iconcls" aria-hidden="true"
                                                    [icon]="['fas', 'calendar-days']"></fa-icon>
                                                {{ article.pub_date.day }} {{
                                                monthName(article.pub_date.month)
                                                }} {{ article.pub_date.year }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="article-box-second-1" *ngIf="showLessFlag">
                        <!-- Image, Title, and Content for the first article -->
                        <div class="article-info-second-1">
                            <div class="row">
                                <div class="col-md-4">
                                    <img width="20" height="20" class="article-explore-image"
                                        *ngIf="article.article_cover_image"
                                        src="{{articleCoverImageUrl+getRelatedArticleImageUrl(article)}}"
                                        alt="Cover image for the article">
                                    <img width="20" height="20" tabindex="0"
                                        *ngIf=" !article.article_cover_image && +article.volume <= 11"
                                        class="card-img-top rvh-article-default-cover"
                                        src="{{default_article_cover_image_upto_11}}" alt="Cover image for the article">
                                    <img width="20" height="20" tabindex="0"
                                        *ngIf=" !article.article_cover_image && +article.volume >11"
                                        class="card-img-top rvh-article-default-cover-green"
                                        src="{{default_article_cover_image_above_11}}"
                                        alt="Cover image for the article">
                                </div>
                                <div class="col-md-8">
                                    <a class="second-title" title="{{article.article_title}}"
                                        [routerLink]="['/articles/'+article.volume+'/'+article.issue+'/'+article.article_id]">{{
                                        getCleanTitle(article.article_title) }}</a>

                                    <h3 class="sub-title-1">
                                        <!-- Loop through authors and display them with commas-->
                                        <!-- <ng-container *ngFor="let author of article.authors; let j = index">
                                                                            {{ author.given_name }} {{ author.surname }}{{ j <
                                                                                article.authors.length - 1 ? ', ' : '' }} </ng-container> -->

                                        <span class="line-clamp-2" title="{{getAuthorNames(article.authors)}}">
                                            {{getAuthorNames(article.authors) }}
                                        </span>
                                    </h3>
                                    <p class="explore-content-second-1">{{article.abstract }}

                                    </p>
                                    <div class="row mt-2 mb-0" style="font-size: 16px;">
                                        <div
                                            [ngClass]="!showLessFlag?'col-sm-6 col-md-12 col-lg-6 col-xl-6 col-xxl-6':'col-sm-12  col-md-6 col-lg-6 col-xl-6 col-xxxl-6'">
                                            <a class="link" target="_blank" title="https://doi.org/{{article.doi}}"
                                                href="https://doi.org/{{article.doi}}"
                                                class="article-doi doi-content-1 doi-underline">
                                                <fa-icon class="iconcls" aria-hidden="true"
                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                {{ article.doi
                                                }}
                                            </a>
                                        </div>
                                        <div
                                            [ngClass]="!showLessFlag?'col-sm-6 col-md-12 col-lg-6 col-xl-6 col-xxl-6 text-end':'col-sm-12  col-md-6 col-lg-6 col-xl-6 col-xxxl-6 text-end'">
                                            <span class="article-doi doi-content" title="{{ article.pub_date.day }} {{
                                                monthName(article.pub_date.month)
                                                }} {{ article.pub_date.year }}">
                                                <fa-icon class="iconcls" aria-hidden="true"
                                                    [icon]="['fas', 'calendar-days']"></fa-icon>
                                                {{ article.pub_date.day }} {{
                                                monthName(article.pub_date.month)
                                                }} {{ article.pub_date.year }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!--load button-->
            <div *ngIf="loading && initialArticleCount < totalArticles && !showLessFlag && !loadMoreFlag"
                class="d-flex justify-content-center pt-2 pb-2" (click)="loadMoreArticles('page_view')">
                <a class="explore-button">
                    <span class="icon">
                        &nbsp;&nbsp;&nbsp;
                    </span>
                    <span class="explore-text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span> </a>
            </div>
            <div *ngIf="!loading && initialArticleCount < totalArticles && !showLessFlag && !loadMoreFlag"
                (click)="loadMoreArticles('page_view')" class="d-flex justify-content-center pt-2 pb-2">
                <a class="explore-button" title="Load more">
                    <span class="icon">

                    </span> Load More
                </a>
            </div>
            <!--class="d-flex justify-content-center"-->
            <div *ngIf="!loading && showLessFlag && (totalArticles > initialArticleCount || !loadMoreFlag)"
                class="d-flex justify-content-center pt-2 pb-2" (click)="showLessArticles('page_view')">
                <a class="explore-button" title="Show less">
                    <span class="icon">

                    </span> Show less
                </a>
            </div>
            <div *ngIf="loading && showLessFlag && (totalArticles > initialArticleCount || !loadMoreFlag)">
                <a class="explore-button">
                    <span class="icon">
                        &nbsp;&nbsp;&nbsp;
                        <!-- <fa-icon class="long-arrow" [icon]="['fas', 'angle-down']" size="2x"></fa-icon> -->
                    </span>
                    <span class="explore-text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </a>
            </div>

        </div>
    </div>
</section>
<app-toaster-downloading [downloading]="downloading" [downloadingData]="downloadingData" [disableBtnPdf]="disableBtnPdf"
    [filename]="filename" [articlelist]="articlelist" [downloadCount]="downloadCount"
    (downloadcount)="downloadcount($event)" [pdfnotexist]="pdfExit"></app-toaster-downloading>



<div #scrollingTitleSection class="article-view-box article-view-box-width   pl-0 scrolling-title d-none"
    style="  box-shadow: 8px 1px 6px rgba(193, 193, 193, 0.3);padding-left:8px !important ; padding-bottom: 4px !important;     padding-right: 18px;    "
    [ngStyle]="{ 'top.px': headerHeight ,'left.px':headingSectionDivLeft}" [class.expanded]="expanded">
    <div class="article-title-content-wrapper row  extra-small-reverse">
        <div class="article-title-content col-sm-4 col-md-3 col-lg-2 col-xl-3 col-xxl-4 "
            title="{{getCleanTitle(setArticleType(articlelist.article_type))}}">
            <h1 *ngIf="!loading" class="change-font scrolling-type">{{setArticleType(articlelist.article_type)}} </h1>
        </div>
        <div
            class="scroll-article-button-content d-flex justify-content-end col-sm-8 col-md-9 col-lg-10 col-xl-9 col-xxl-8 extra-small-reverse-article-view-wrapper">
            <span class="me-lg-2 me-md-0" *ngIf="!hideExpanIcon">
                <div #expantooltip [ngClass]="expanded ? 'active-icon' : 'inactive-icon'" tabindex="0" role="button"
                    aria-label="Press enter to change layout of the article" (click)="toggleExpand()"
                    (keyup.enter)="toggleExpand()" (keyup.space)="toggleExpand()" (mouseenter)="setTooltipMsg()"
                    placement="bottom"
                    [title]="titleMsg && !expanded?'Change the article layout to full width ':'Exit fullwidth layout'"
                    triggers="click" [openDelay]="1000" [closeDelay]="200" tooltipClass="color-change-tootltip"
                    [ngbTooltip]="expanded?'You have switched your layout to full width. To go back to fixed width, press this button.':''">
                    <fa-icon aria-hidden="true" [icon]="expanded?['fas', 'compress']:['fas', 'expand']"></fa-icon>
                </div>
            </span>
            <div class="article-view-wrapper scroll-article-view-wrapper me-3 "
                *ngIf='!loading &&  viewActiveIcon==="normal"'>
                <fa-icon aria-hidden="true" class="me-3" [icon]="['fas', 'eye']"
                    class="custom-class-icon me-2 icon-class">
                </fa-icon>
                <span class="me-2 article-view-normal change-font scroll-view-normal" (click)="openDyslexic('normal')"
                    (keyup.enter)="openDyslexic('normal')" (keyup.space)="openDyslexic('normal')" #scrollToTop
                    [ngbTooltip]="'article_view.Normal_view'|translate" [placement]="'bottom'">
                    Normal View </span>

                <span class="article-view-dyslexic change-font  scroll-view-dyslexic" (click)="openDyslexic('Dyslexic')"
                    (keyup.enter)="openDyslexic('Dyslexic')" (keyup.space)="openDyslexic('Dyslexic')" #scrollToTop
                    [ngbTooltip]="'article_view.Dyslexic_view'|translate" [placement]="'bottom'">
                    Dyslexic View
                </span>
            </div>
            <div class="article-view-wrapper me-3" style="padding: 7px 10px 7px 10px; "
                *ngIf=' !loading && viewActiveIcon==="Dyslexic"'>
                <fa-icon aria-hidden="true" class="me-3 icon-class" [icon]="['fas', 'eye']">
                </fa-icon>
                <span class="me-2 article-view-dyslexic" (click)="openDyslexic('normal')"
                    (keyup.enter)="openDyslexic('normal')" (keyup.space)="openDyslexic('normal')" #scrollToTop
                    [ngbTooltip]="'article_view.Normal_view'|translate" [placement]="'bottom'">
                    Normal View </span>
                <span class="article-view-normal" (click)="openDyslexic('Dyslexic')"
                    (keyup.enter)="openDyslexic('Dyslexic')" (keyup.space)="openDyslexic('Dyslexic')" #scrollToTop>
                    Dyslexic View
                </span>
            </div>

            <span class="image-iconspan ml-3 mt-2">
                <img width="20" height="20" *ngIf="loading" class="open-access-logo content-loader">
                <img width="20" height="20" *ngIf="!loading" src='assets/logos/open_access_logo.webp'
                    class="open-access-logo width-change" [ngbTooltip]="'article_listing.open_access'|translate"
                    [placement]="'bottom'" alt="Open access article">
            </span>
        </div>

    </div>


    <div class="col-sm-12 col-md-12 rvh-artic-basic-info" #basicInfo>
        <span class="d-flex justify-content ">

            <h2 *ngIf="!loading" class="rvh-article-title-name article-title-lineclamp change-font-heading m-0"
                tabindex="0" [innerHTML]="structuringData(articlelist.article_title) | highlightSearch:''"
                (mouseover)="showTooltip($event)" (mousemove)="leaveTooltip($event,'content')"
                (mouseleave)="leaveTooltip($event,'content')">
            </h2>
        </span>

        <p *ngIf="!loading" class=" author mb-2" tabindex="0"
            [innerHTML]="structuringData(getAuthorlist(articlelist.authors))| highlightSearch:''"
            (mousemove)="leaveTooltip($event,'author')" (mouseleave)="leaveTooltip($event,'author')">
        </p>


    </div>

</div>

<div *ngIf=" articleOutline && articleOutline.length >0"
    class="small-device-outline d-md-none d-lg-none d-xl-none d-xxl-none "
    [ngClass]="{'show': toggleOutline, 'hide': !toggleOutline}">


    <div class="abstract-title-content  pl-2" *ngIf="articleOutline&& articleOutline.length >0">

        <h4 class="navigation-heading pt-3" tabindex="0" *ngIf="!loading">
            <fa-icon class="iconcls citation-icon Outline Outlineicon icon-class" aria-hidden="true"
                [icon]="['fas', 'list-ul']">
            </fa-icon>
            <span class="nav-heading-content Outline">
                Article Outline
            </span>
        </h4>
        <div class="page-content pl-4 ml-1 page-container" id="page-content">
            <div class="row">
                <div *ngIf="loading" class="timeline block mb-4">
                    <div class="tl-item" *ngFor="let content of abstractcontentloader; let i = index">
                        <div class="tl-dot b-warning secondary">
                        </div>
                        <div class="tl-content secondary content-loader">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </div>
                    </div>
                </div>
                <div *ngIf="!loading &&  articleOutline && articleOutline.length >0" #articleHead
                    class="timeline block mb-4">
                    <div class="tl-item" *ngFor="let content of articleOutline; let i = index">
                        <div class="tl-dot b-warning secondary" [class.list-content]="activeline[i]">
                        </div>
                        <div id="outline{{content.outlineId}}" class="tl-content secondary"
                            [class.badge-content]="activeline[i]" (click)="styleChange(i,content.outlineId)"
                            (keyup.enter)="styleChange(i,content.outlineId)"
                            (keyup.space)="styleChange(i,content.outlineId)" tabindex="0" role="contentinfo">
                            {{content.title}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>